import React__default from 'react';
import { Button } from '../../primitives/Button.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

const getButtonClasses = () => {
  return 'min-h-[theme(spacing.8)] min-w-[theme(spacing.8)] gap-1 h-max leading-5 inline-flex items-center justify-center';
};
const getAppearanceClasses = (value, icon = false) => {
  switch (value) {
    case 'primary':
      return `yt-blue-solid focus:bg-blue focus:text-white focus:yt-focus active:bg-blue-dark active:text-white hover:bg-blue-light hover:text-white hover:focus:bg-blue-light hover:focus:border-blue-light hover:focus:text-white disabled:hover:yt-blue-solid disabled:hover:hover:border-blue`;

    case 'danger':
      return `yt-red-solid focus:bg-red focus:text-white focus:yt-focus-red active:bg-red-dark active:text-white hover:bg-red-light hover:text-white hover:focus:bg-red-light hover:focus:text-white disabled:hover:yt-red-solid`;

    case 'ghost':
      return `bg-white shadow-[inset_0_0_0_1px_theme(colors.blue.DEFAULT)] text-blue focus:bg-transparent focus:text-blue active:bg-blue-lightest focus:!shadow-[inset_0_0_0_1px_theme(colors.blue.DEFAULT),0_0_0_2px_rgba(0,99,255,0.25)] active:text-blue-dark hover:bg-blue-lightest hover:shadow-[inset_0_0_0_1px_theme(colors.blue.light)] hover:text-blue-light hover:focus:bg-blue-lightest hover:focus:!shadow-[inset_0_0_0_1px_theme(colors.blue.light),0_0_0_2px_rgba(0,99,255,0.25)] hover:focus:text-blue-light`;

    case 'discrete':
      {
        if (icon) {
          return `bg-transparent text-black border-transparent focus:text-black focus:yt-focus active:text-black hover:text-grey-darkest hover:focus:text-grey-darkest disabled:hover:text-black `;
        }

        return `yt-transparent focus:text-blue focus:yt-focus active:text-blue-dark hover:text-blue-light hover:focus:text-blue-light disabled:hover:yt-transparent`;
      }

    default:
      return `yt-grey-solid focus:bg-grey focus:yt-focus active:bg-grey-dark active:text-black hover:bg-grey-light hover:text-grey-darkest hover:focus:bg-grey-light hover:focus:text-grey-darkest disabled:hover:yt-grey-solid`;
  }
};
const createButton = (props, className, ref) => {
  const {
    dialog,
    hanger,
    menu,
    popover,
    tooltip,
    ...otherProps
  } = props;
  let button = React__default.createElement(Button, Object.assign({}, otherProps, {
    className: className,
    ref: ref
  }));

  if (typeof dialog === 'function') {
    button = dialog({
      trigger: button
    });
  } else if (typeof menu === 'function') {
    button = menu({
      trigger: button,
      appearance: otherProps.appearance
    });
  } else if (typeof popover === 'function') {
    button = popover({
      trigger: button
    });
  }

  if (typeof hanger === 'function') {
    button = hanger({
      anchor: button
    });
  }

  if (tooltip) {
    button = React__default.createElement(Tooltip, {
      title: tooltip
    }, button);
  }

  return button;
};

export { createButton, getAppearanceClasses, getButtonClasses };
//# sourceMappingURL=util.js.map
